// extracted by mini-css-extract-plugin
export default {"mainContainer":"Loading_mainContainer__L7Q+v","fullPage":"Loading_fullPage__iimpg"};